/** Supabase Realtime Presence channel — shared by site header counter and admin spectator. */
export const SITE_PRESENCE_CHANNEL = 'site-presence-online'

const CLIENT_STORAGE_KEY = 'comfyflow-presence-client-id'

export function getPresenceClientKey(): string {
  try {
    let id = sessionStorage.getItem(CLIENT_STORAGE_KEY)
    if (!id) {
      id = crypto.randomUUID()
      sessionStorage.setItem(CLIENT_STORAGE_KEY, id)
    }
    return id
  } catch {
    return crypto.randomUUID()
  }
}
